import moment from 'moment-timezone';
import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { Link } from 'react-router-dom';

import { getInvoiceDevolutionList } from '../app/store/actions/invoiceDevolution';
import PanelSidebar from '../components/panel/PanelSidebar';
import PriceComponent from '../components/price/Price';
import INVOICE_DEVOLUTION from '../data/invoiceDevolution';
import ROUTES from '../data/routes';
import { history } from '../routers/AppRouter';

class InvoiceDevolutionPage extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      filterBy: INVOICE_DEVOLUTION.types[0].label,
    };
  }

  componentDidMount = () => {
    setTimeout(async () => {
      const { clientId } = this.props;
      const { filterBy } = this.state;

      await this.props.getInvoiceDevolutionList({ clientId }, filterBy);
    }, 0);
  }

  filterInvoiceDevolutionTypes = async (invoiceDevolutionType) => {
    const { clientId } = this.props;

    await this.setState({ filterBy: invoiceDevolutionType });
    await this.props.getInvoiceDevolutionList({ clientId }, invoiceDevolutionType);
  }

  invoiceDevolutionValue = (itens) => {
    let totalValue = 0;
    for (let index = 0; index < itens.length; index += 1) {
      const element = itens[index];
      totalValue += (element.quantity * element.unitValue);
    }

    return (
      <PriceComponent value={Number(totalValue)} />
    );
  }

  invoiceDevolutionStatus = (status) => {
    switch (status) {
      case INVOICE_DEVOLUTION.types[1].label:
        return I18n.t('invoiceDevolutionPending');
      case INVOICE_DEVOLUTION.types[2].label:
        return I18n.t('invoiceDevolutionAccepted');
      case INVOICE_DEVOLUTION.types[3].label:
        return I18n.t('invoiceDevolutionRecused');
      case INVOICE_DEVOLUTION.types[4].label:
        return I18n.t('invoiceDevolutionFinished');
      case INVOICE_DEVOLUTION.types[5].label:
        return I18n.t('invoiceDevolutionCancelled');
      default:
        return '';
    }
  }

  renderInvoiceDevolutionList = InvoiceDevolutionList => InvoiceDevolutionList.map((InvoiceDevolution) => {
    const date = moment(InvoiceDevolution.createdAt);
    const day = date.format('DD');
    const month = date.format('MMM');

    return (
      <Link
        key={InvoiceDevolution.sphereDevolutionId}
        to={{
          pathname: ROUTES.INVOICE_DEVOLUTION_DETAILS,
          state: {
            nciNumber: InvoiceDevolution.sphereDevolutionId,
            devolutionNumber: InvoiceDevolution.purchaseInvoiceNumber,
          },
        }}
        className="requests-item"
        style={{ textDecoration: 'none' }}
      >
        <div className="date">
          <strong>{day}</strong>
          <span className="line" />
          {month}
        </div>
        <div className="content">
          <span className="content-item">
            <strong>{I18n.t('invoiceDevolutionValue')}</strong>
            {this.invoiceDevolutionValue(InvoiceDevolution.sphereNCI.NCIItens)}
          </span>
          <span className="content-item">
            <strong>{I18n.t('invoiceDevolutionNumber')}</strong>
            {`${InvoiceDevolution.sphereNCI.invoiceDevolution || ''}`}
          </span>
          <span className="content-item">
            <strong>{I18n.t('nciCode')}</strong>
            {`${InvoiceDevolution.sphereNCI.id}`}
          </span>
          <span className="content-item">
            <strong>{I18n.t('dateOfDevolution')}</strong>
            {`${date.format('LLL')}`}
          </span>
          <span className="content-item">
            <strong>{I18n.t('requestingUser')}</strong>
            {`${InvoiceDevolution.purchaseInvoice.invoicesPurchases.user.email}`}
          </span>
          <button type="button" className="btn cursorPointer" style={{ width: 'auto' }}>
            {this.invoiceDevolutionStatus(InvoiceDevolution.sphereNCI.statusCheckbuy)}
          </button>
        </div>
      </Link>
    );
  })

  render() {
    const { invoiceDevolutionList } = this.props;

    return (
      <main>
        <div className="section section-panel">
          <div className="container">
            <h1 className="panel-title">{I18n.t('documentList2')}</h1>
            <div className="panel-content">
              <PanelSidebar />
              <div className="box-content requests">
                <div className="requests-header">
                  <div className="filter">
                    <label htmlFor="devolutionType">{I18n.t('filterBy')}</label>
                    <div className="select select--white">
                      <select
                        id="devolutionType"
                        name="filterBy"
                        value={this.state.filterBy}
                        onChange={event => this.filterInvoiceDevolutionTypes(event.target.value)}
                      >
                        {Object.keys(INVOICE_DEVOLUTION.types).map(element => (
                          <option
                            key={INVOICE_DEVOLUTION.types[element].value}
                            value={INVOICE_DEVOLUTION.types[element].label}
                          >
                            {I18n.t(INVOICE_DEVOLUTION.types[element].label)}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <button
                    type="button"
                    className="btn cursorPointer"
                    onClick={() => (history.push(ROUTES.INVOICE_DEVOLUTION_SOLICITATION))}
                  >
                    {I18n.t('requestInvoiceDevolution')}
                  </button>
                </div>
                {invoiceDevolutionList && invoiceDevolutionList.length > 0
                  ? this.renderInvoiceDevolutionList(invoiceDevolutionList)
                  : (
                    <p style={{ marginTop: '75px', textAlign: 'center' }}>
                      {I18n.t('noReturnDevolutionSolicitationMade')}
                    </p>
                  )}
              </div>
            </div>
          </div>
        </div>
      </main>
    );
  }
}

const mapStateToProps = state => ({
  clientId: state.contracts.selected.client.id,
  invoiceDevolutionList: state.invoiceDevolution.invoiceDevolutionList,
});

const mapDispatchToProps = dispatch => ({
  getInvoiceDevolutionList: (data, filterBy) => dispatch(getInvoiceDevolutionList(data, filterBy)),
});

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceDevolutionPage);
